import { slices } from "@/constants/sliceNames";
import * as defaultState from "./reducers/initialStates";
import { mergeDeep } from "./utils";

const PERSISTID = "AVERROES_PERSIST_STATE";
const LOCAL_STORAGE_VERSION = 2;
const LOCAL_STORAGE_VERSION_KEY = "LOCAL_STORAGE_VERSION";

/**
 * called just on create the store and initialize it
 */
export const loadPersistState = () => {
  try {
    checkLocalStorageVersion();

    let serializedState = localStorage.getItem(PERSISTID);

    if (!serializedState) serializedState = "{}";

    const state = {};
    mergeDeep(state, defaultState, JSON.parse(serializedState));
    return state;
  } catch (e) {
    console.error(e);
    return undefined;
  }
};

let prevstate = defaultState;
export const savePersistState = (state = defaultState) => {
  //if no changes on persist data return
  // if (state[slices.auth].remember === prevstate[slices.auth].remember) return;

  try {
    const serializedState = JSON.stringify({
      [slices.auth]: {
        userToken: state[slices.auth].userToken,
        remember: state[slices.auth].remember,
      },
    });

    localStorage.setItem(PERSISTID, serializedState);
  } catch (e) {
    console.error(e);
    return;
  }

  prevstate = state;
};

function checkLocalStorageVersion() {
  const localStorageVersion = localStorage.getItem(LOCAL_STORAGE_VERSION_KEY);
  // eslint-disable-next-line eqeqeq
  if (localStorageVersion != LOCAL_STORAGE_VERSION) {
    localStorage.removeItem(PERSISTID);
    localStorage.setItem(LOCAL_STORAGE_VERSION_KEY, LOCAL_STORAGE_VERSION);
  }
}
